import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SellerAccountView } from '../../core/model/seller-account-view.model';
import { LemonwayOnboardingService } from '../profile/services/lemonway-onboarding.service';
import { OnboardingErrorsDialogComponent } from '../profile/dialogs/onboarding-errors-dialog.component';
import { MainService } from '../../children/main/main.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-onboarding-alert-dialog',
    templateUrl: './onboarding-alert-dialog.component.html',
    styleUrls: ['./onboarding-alert-dialog.component.scss']
})
export class OnboardingAlertDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<OnboardingAlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { user: SellerAccountView },
        private lemonwayService: LemonwayOnboardingService,
        private _dialog: MatDialog,
        private _snackBar: MatSnackBar,
        public mainService: MainService,
    ) { }

    get hasOnboardingAccount(): boolean {
        return this.data.user?.showOnboardingButton === 2;
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    startOnboarding(): void {
        const user = this.mainService.user as SellerAccountView;
        const sellerId = user?.sellerId;
        if (!sellerId) return;

        const hasAccountId = !!user.onboardingAccountId;
        const hasProfileId = !!user.onboardingId;

        if (!hasAccountId && !hasProfileId) {
            // create, then initiate, then resume
            this.lemonwayService.createAccount(sellerId).pipe(
                switchMap(errors => {
                    if (errors && errors.length > 0) {
                        this._dialog.open(OnboardingErrorsDialogComponent, {
                            data: { errors },
                            width: '500px'
                        });
                        return of(null);
                    }
                    return this.lemonwayService.initiateOnboarding(sellerId);
                }),
                switchMap(initiateErrors => {
                    if (!initiateErrors) return of(null);
                    if (initiateErrors.length > 0) {
                        this._dialog.open(OnboardingErrorsDialogComponent, {
                            data: { errors: initiateErrors },
                            width: '500px'
                        });
                        return of(null);
                    }
                    return this.lemonwayService.getResumeUrl(sellerId);
                })
            ).subscribe(() => {
                this.dialogRef.close();
            });
        } else if (hasAccountId && !hasProfileId) {
            // initiate, then resume
            this.lemonwayService.initiateOnboarding(sellerId).pipe(
                switchMap(initiateErrors => {
                    if (initiateErrors && initiateErrors.length > 0) {
                        this._dialog.open(OnboardingErrorsDialogComponent, {
                            data: { errors: initiateErrors },
                            width: '500px'
                        });
                        return of(null);
                    }
                    return this.lemonwayService.getResumeUrl(sellerId);
                })
            ).subscribe(() => {
                this.dialogRef.close();
            });
        } else if (hasAccountId && hasProfileId) {
            // solo resume
            this.lemonwayService.getResumeUrl(sellerId).subscribe(() => {
                this.dialogRef.close();
            });
        }
    }

    resumeOnboarding(): void {
        const user = this.mainService.user as SellerAccountView;
        const sellerId = user?.sellerId;
        if (!sellerId) return;
        const hasAccountId = !!user.onboardingAccountId;
        const hasProfileId = !!user.onboardingId;
        if (hasAccountId && !hasProfileId) {
            // initiate, then resume
            this.lemonwayService.initiateOnboarding(sellerId).pipe(
                switchMap(initiateErrors => {
                    if (initiateErrors && initiateErrors.length > 0) {
                        this._dialog.open(OnboardingErrorsDialogComponent, {
                            data: { errors: initiateErrors },
                            width: '500px'
                        });
                        return of(null);
                    }
                    return this.lemonwayService.getResumeUrl(sellerId);
                })
            ).subscribe(() => {
                this.dialogRef.close();
            });
        } else if (hasAccountId && hasProfileId) {
            // solo resume
            this.lemonwayService.getResumeUrl(sellerId).subscribe(() => {
                this.dialogRef.close();
            });
        }
    }
} 